<template>
  <div class="page-container">
    <Header></Header>
    
    <div class="main-layout">
      <div class="sidebar">
        <MenuList></MenuList>
      </div>
      
      <div class="content">
        <!-- 操作栏 -->
        <div class="action-bar">
          <el-tooltip effect="dark" content="告诉您下一步怎么操作" placement="bottom">
            <el-button type="danger" plain size="small" @click="whatIsNextStep">
              <i class="el-icon-question"></i>表格导入后下一步操作？
            </el-button>
          </el-tooltip>
          <el-tooltip effect="dark" content="手上已经有表格,制表有点麻烦,直接导入吧" placement="bottom">
            <el-button type="primary" size="small" @click="importExcel">
              <i class="el-icon-upload2"></i>导入Excel
            </el-button>
          </el-tooltip>
        </div>
        
        <!-- 数据表格 -->
        <div class="table-container">
          <el-table 
            :data="tableData" 
            stripe 
            class="data-table"
            :header-cell-style="{background:'#f5f7fa',color:'#606266',fontWeight:'600'}"
            v-loading="loading">
            
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            
            <el-table-column prop="form_name" label="表格名称" min-width="180">
              <template slot-scope="scope">
                <span :class="{'text-bold': tableData[scope.$index].form_owner!='我的'}">
                  {{scope.row.form_name}}
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="conditions" label="领表查询条件" width="120"></el-table-column>
            
            <el-table-column label="填写状态" width="80" align="center">
              <template slot-scope="scope">
                <span :class="scope.row.state=='1' ? 'status-success' : 'status-danger'">
                  {{scope.row.state=='1' ? '可填' : '不可填写'}}
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="recieve_code" label="核对码" width="120" align="center"></el-table-column>
            
            <el-table-column label="数据(条)" align="center" width="80">
              <template slot-scope="scope">
                <span :class="scope.row.submit_count===0 ? 'text-danger' : ''">
                  {{scope.row.submit_count===0 ? '空表' : scope.row.submit_count}}
                </span>
              </template>
            </el-table-column>
            
            <el-table-column label="核对率" width="100" align="center">
              <template slot-scope="scope">
                <el-progress 
                  :percentage="getSearchedPercent(scope.row.total,scope.row.searched_count)" 
                  :color="progressColors"
                  :show-text="true"
                  :stroke-width="8">
                </el-progress>
              </template>
            </el-table-column>
            
            <el-table-column prop="create_time" label="创建时间" align="center" width="160"></el-table-column>

            <el-table-column label="操作" align="center" width="100" fixed="right">
              <template slot-scope="scope">
                <el-dropdown trigger="click" size="small">
                  <el-button type="primary" plain size="mini">
                    操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="browseData(scope.$index, tableData)">
                      <i class="el-icon-view"></i>浏览数据
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="sendForm(scope.$index, tableData)" v-if="tableData[scope.$index].form_owner=='我的'">
                      <i class="el-icon-share"></i>转发核对表
                    </el-dropdown-item>
                    <!-- <el-dropdown-item @click.native="testQuery(scope.$index, tableData)">
                      <i class="el-icon-mobile-phone"></i>测试功能
                    </el-dropdown-item> -->
                    <el-dropdown-item @click.native="resetQueryConditions(scope.$index, tableData)">
                      <i class="el-icon-refresh"></i>重设查询条件
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="editFormName(scope.$index, tableData)">
                      <i class="el-icon-edit"></i>修改名称
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="editFormComment(scope.$index, tableData)">
                      <i class="el-icon-document"></i>{{tableData[scope.$index].comment ? '修改说明' : '添加说明'}}
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="exportData(scope.$index, tableData)">
                      <i class="el-icon-download"></i>导出核对表
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="deleteForm(scope.$index, tableData)" class="danger-item">
                      <i class="el-icon-delete"></i>删除核对表
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 导出选项弹窗 -->
    <el-dialog title="导出核对表" :visible.sync="exportExcelDialogVisible" :close-on-click-modal="false" width="450px" custom-class="custom-dialog">
      <div class="export-options">
        <p class="dialog-tip">请选择数据导出范围：</p>
        <el-radio-group v-model="export_range" class="radio-group">
          <el-radio :label="0">未填写或未核对数据</el-radio>
          <el-radio :label="1">已经填写或已经核对数据</el-radio>
          <el-radio :label="2">全部数据</el-radio>
        </el-radio-group>
        <p class="warning-text">注：数据超过100条时，导出会需要一些时间，请耐心等待。导出时请勿关闭此窗口！</p>
      </div>
      <div slot="footer">
        <el-button @click="exportExcelDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="exportDataAction">立即导出</el-button>
      </div>
    </el-dialog>

    <!-- Excel下载弹窗 -->
    <el-dialog title="导出成功" :visible.sync="downloadExcelDialogVisible" :close-on-click-modal="false" custom-class="custom-dialog">
      <p class="dialog-content">Excel文件已经生成，请点击下面的链接下载。如操作失败，请用小程序操作。</p>
      <a :href="current_download_file_name" target="_blank" class="download-link">{{current_download_file_name}}</a>
      <div slot="footer">
        <el-button @click="copyDownloadUrl">复制链接</el-button>
        <el-button type="primary" @click="downloadExcel">下载文件</el-button>
        <el-button @click="downloadExcelDialogVisible=false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 发布查询弹窗 -->
    <el-dialog title="发布查询" :visible.sync="sendFormDialogVisible" :close-on-click-modal="false" width="500px" custom-class="custom-dialog">
      <div class="publish-methods">
        <div class="method-item">
          <h4><i class="el-icon-picture-outline"></i>方法一、转发二维码</h4>
          <p>在二维码上右键"图片另存为..."下载此查询的二维码，打印张贴或者在微信中转发。</p>
          <div class="qrcode-box">
            <img :src="qrcode_filename" alt="二维码"/>
          </div>
        </div>
        <div class="method-item">
          <h4><i class="el-icon-share"></i>方法二、转发小程序</h4>
          <p>在手机<span class="highlight">核对信息小程序</span>中点开这个查询，点击"发布查询"→"转发到群"。</p>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="sendFormDialogVisible=false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 下一步操作提示 -->
    <el-dialog title="表格导好了,怎么让别人领表填写？" :visible.sync="howToNextStepDialogVisible" width="480px" custom-class="custom-dialog">
      <div class="steps-guide">
        <div class="step-item-dialog">
          <span class="step-num">1</span>
          <span>扫下面的二维码打开"核对信息"小程序</span>
        </div>
        <div class="step-item-dialog">
          <span class="step-num">2</span>
          <span>在"发布查询"中找到刚发布的核对表</span>
        </div>
        <div class="step-item-dialog">
          <span class="step-num">3</span>
          <span>点"转发表格"转发小程序或二维码让大家查询填表</span>
        </div>
        <div class="qrcode-center">
          <p class="qrcode-tip">微信扫码打开核对信息小程序</p>
          <img src="/checking/images/checking_qrcode.jpg" alt="小程序码" class="qrcode-img"/>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="howToNextStepDialogVisible = false">知道了</el-button>
      </div>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <el-dialog title="删除核对表" :visible.sync="deleteFormConfirmDialogVisible" width="420px" custom-class="custom-dialog">
      <div class="confirm-content">
        <p class="danger-text">删除后已经发放的核对单将无法恢复，如确定要删除，请输入删除验证码。</p>
        <p class="verify-code">删除验证码：<span class="code">{{random_num}}</span></p>
        <el-input v-model="tmp_random_num" placeholder="请输入验证码" size="medium"></el-input>
      </div>
      <div slot="footer">
        <el-button @click="deleteFormConfirmDialogVisible = false">取消</el-button>
        <el-button type="danger" @click="deleteSelectedForm">永久删除</el-button>
      </div>
    </el-dialog>

    <!-- 修改名称弹窗 -->
    <el-dialog title="修改核对表名称" :close-on-click-modal="false" :visible.sync="editFormNameDialogVisible" width="400px" custom-class="custom-dialog">
      <el-input v-model="selectedFormName" placeholder="请输入核对表名称" size="medium"></el-input>
      <div slot="footer">
        <el-button @click="editFormNameDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="editFormNameSave">保存</el-button>
      </div>
    </el-dialog>

    <!-- 核对说明弹窗 -->
    <el-dialog title="核对说明" :close-on-click-modal="false" :visible.sync="editFormCommentDialogVisible" width="450px" custom-class="custom-dialog">
      <el-input type="textarea" :rows="4" v-model="selectedFormComment" placeholder="核对说明会显示在用户查询页面，主要是说明如何核对以及注意事项"></el-input>
      <div slot="footer">
        <el-button @click="editFormCommentDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="editFormCommentSave">保存</el-button>
      </div>
    </el-dialog>

    <!-- 测试查询弹窗 -->
    <el-dialog title="测试查询" :visible.sync="testQueryDialogVisible" width="360px" custom-class="custom-dialog">
      <p class="dialog-tip">微信扫描二维码打开查询测试</p>
      <div class="qrcode-center">
        <img :src="qrcode_filename" alt="测试二维码" class="qrcode-img"/>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="testQueryDialogVisible=false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MenuList from './menu.vue'
import Header from './head.vue'
import Utils from '../utils/utils.js'

export default {
  components: {
    MenuList,
    Header
  },
  data() {
    return {
      username: '',
      tableData: [],
      loading: false,
      deleteFormConfirmDialogVisible: false,
      exportExcelDialogVisible: false,
      downloadExcelDialogVisible: false,
      sendFormDialogVisible: false,
      howToNextStepDialogVisible: false,
      editFormNameDialogVisible: false,
      editFormCommentDialogVisible: false,
      testQueryDialogVisible: false,
      position: -1,
      msg: '',
      random_num: '',
      tmp_random_num: '',
      current_download_file_name: '',
      selected_form_id: '',
      selected_form_name: '',
      selectedFormName: '',
      selectedFormComment: '',
      qrcode_filename: '',
      export_range: '',
      export_form_id: '',
      progressColors: [
        {color: '#f56c6c', percentage: 30},
        {color: '#e6a23c', percentage: 70},
        {color: '#67c23a', percentage: 100}
      ]
    }
  },
  mounted() {
    this.username = this.$session.get('USERNAME')
  },
  created() {
    this.username = this.$session.get('USERNAME')
    this.loadData()
  },
  watch: {
    $route() {
      this.loadData()
    }
  },
  methods: {
    loadData() {
      this.loading = true
      let that = this
      var requestUrl = '/checking/web/_load_queries.jsp'
      this.axios.get(requestUrl, {
        params: { username: that.username }
      }).then(function(response) {
        that.tableData = response.data
        that.loading = false
      }).catch(function(error) {
        console.log(error)
        that.loading = false
      })
    },
    getSearchedPercent(total, searched_count) {
      var percent = 0
      if (total == 0) {
        percent = 0
      } else {
        percent = ((searched_count / total) * 100)
      }
      return parseFloat(percent.toFixed(1))
    },
    deleteForm(index, rows) {
      this.random_num = Utils.getRandomNum(4)
      this.tmp_random_num = ''
      this.selected_form_id = rows[index].id
      this.position = index
      
      var state = rows[index].state
      if (state === 2) {
        this.$alert('《' + rows[index].form_name + '》正在填写，如要删除，请先收回表格！', '提示', {
          confirmButtonText: '确定'
        })
        return
      }

      this.deleteFormConfirmDialogVisible = true
    },
    deleteSelectedForm() {
      if (Utils.isEmpty(this.tmp_random_num)) {
        this.$message.error('请输入删除验证码！')
        return
      }
      if (this.tmp_random_num !== this.random_num) {
        this.$message.error('删除验证码不正确，请重新输入！')
        return
      }

      let that = this
      this.deleteFormConfirmDialogVisible = false
      var requestUrl = '/checking/web/_delete_form_data_and_template.jsp'
      this.axios.get(requestUrl, {
        params: {
          form_id: that.selected_form_id,
          equipment: that.username
        }
      }).then(function() {
        that.tableData.splice(that.position, 1)
        that.tmp_random_num = ''
        that.$message.success('删除成功！')
      })
    },
    editFormName(index, rows) {
      this.position = index
      this.selected_form_id = rows[index].id
      this.selectedFormName = rows[index].form_name
      this.editFormNameDialogVisible = true
    },
    editFormNameSave() {
      if (Utils.isEmpty(this.selectedFormName)) {
        this.$message.error('名称不能为空！')
        return
      }
      let that = this
      var requestUrl = '/checking/web/_update_form_name.jsp'
      this.axios.get(requestUrl, {
        params: {
          form_id: that.selected_form_id,
          form_name: that.selectedFormName
        }
      }).then(function() {
        that.selectedFormName = ''
        that.selected_form_id = ''
        that.editFormNameDialogVisible = false
        that.loadData()
        that.$message.success('修改成功！')
      })
    },
    editFormComment(index, rows) {
      this.position = index
      this.selected_form_id = rows[index].id
      this.selectedFormName = rows[index].form_name
      this.selectedFormComment = rows[index].comment || ''
      this.editFormCommentDialogVisible = true
    },
    editFormCommentSave() {
      let that = this
      var requestUrl = '/checking/web/_update_form_comment.jsp'
      this.axios.get(requestUrl, {
        params: {
          form_id: that.selected_form_id,
          form_comment: that.selectedFormComment
        }
      }).then(function() {
        that.selected_form_id = ''
        that.selectedFormComment = ''
        that.editFormCommentDialogVisible = false
        that.loadData()
        that.$message.success('修改成功！')
      })
    },
    importExcel() {
      this.$alert('请在左侧的菜单上选择导入方式！', '提示', {
        confirmButtonText: '知道了',
        showCancelButton: false
      })
    },
    exportData(index, rows) {
      this.export_form_id = rows[index].id
      var exist_image_field = rows[index].exist_image_field
      if (exist_image_field == '1') {
        this.$alert('带有图片或签名的核对表导出时需要消耗大量时间，请用手机端小程序操作。', '操作提醒', {
          confirmButtonText: '知道了'
        })
      } else {
        this.exportExcelDialogVisible = true
      }
    },
    exportDataAction() {
      if (this.export_range === '') {
        this.$message.error('请选择导出数据范围！')
        return
      }

      this.loading = true
      let that = this
      var requestUrl = '/checking/web/_export_to_excel.jsp'
      this.axios.get(requestUrl, {
        params: {
          form_id: that.export_form_id,
          export_range: that.export_range
        }
      }).then(function(response) {
        that.loading = false
        that.export_form_id = ''
        that.export_range = ''
        that.current_download_file_name = '/checking' + response.data.file_url
        that.exportExcelDialogVisible = false
        that.downloadExcelDialogVisible = true
      }).catch(function(error) {
        console.log(error)
        that.loading = false
      })
    },
    downloadExcel() {
      this.downloadExcelDialogVisible = false
      window.open(this.current_download_file_name)
    },
    copyDownloadUrl() {
      var urlstr = window.location.origin + this.current_download_file_name
      this.$copyText(urlstr).then(() => {
        this.$message.success('下载网址复制成功')
      }).catch(() => {
        this.$message.error('下载网址复制失败')
      })
    },
    sendForm(index, rows) {
      this.selected_form_name = rows[index].form_name
      this.selected_form_id = rows[index].id
      let that = this
      this.loading = true
      var requestUrl = "/checking/web/_qrcode_generator.jsp?form_id=" + this.selected_form_id
      this.axios.get(requestUrl, {
        params: {
          form_id: that.selected_form_id,
          equipment: that.username
        }
      }).then(function(response) {
        that.qrcode_filename = '/checking' + response.data.file_name
        that.sendFormDialogVisible = true
        that.loading = false
      }).catch(function(error) {
        console.log(error)
        that.loading = false
      })
    },
    browseData(index, rows) {
      var formId = rows[index].id
      var formName = rows[index].form_name
      this.$router.push({
        name: 'browse_all_data',
        params: { form_id: formId, form_name: formName }
      })
    },
    whatIsNextStep() {
      this.howToNextStepDialogVisible = true
    },
    testQuery(index, rows) {
      this.selected_form_name = rows[index].form_name
      this.selected_form_id = rows[index].id
      let that = this
      this.loading = true
      var requestUrl = "/checking/phone/qrcode_generator.jsp?form_id=" + this.selected_form_id
      this.axios.get(requestUrl, {
        params: {
          form_id: that.selected_form_id,
          equipment: that.username
        }
      }).then(function(response) {
        that.qrcode_filename = '/checking' + response.data.file_name
        that.testQueryDialogVisible = true
        that.loading = false
      }).catch(function(error) {
        console.log(error)
        that.loading = false
      })
    },
    resetQueryConditions(index, rows) {
      this.selected_form_name = rows[index].form_name
      this.selected_form_id = rows[index].id
      this.$router.push({
        name: 'reset_query_conditions',
        params: {
          form_id: this.selected_form_id,
          form_name: this.selected_form_name
        }
      })
    }
  }
}
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
}

.main-layout {
  flex: 1;
  display: flex;
}

.sidebar {
  width: 220px;
  background: #fff;
  border-right: 1px solid #e8ecf1;
  flex-shrink: 0;
}

.content {
  flex: 1;
  padding: 20px;
  overflow: auto;
}

/* 操作栏 */
.action-bar {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-bottom: 16px;
}

/* 表格容器 */
.table-container {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}

.data-table {
  width: 100%;
}

/* 状态样式 */
.status-success {
  color: #67c23a;
  font-weight: 500;
}

.status-danger {
  color: #f56c6c;
  font-weight: 500;
}

.text-danger {
  color: #f56c6c;
}

.text-bold {
  font-weight: 600;
}

/* 下拉菜单 */
::v-deep .el-dropdown-menu__item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  font-size: 14px;
}

::v-deep .el-dropdown-menu__item i {
  font-size: 14px;
  min-width: 16px;
  text-align: center;
}

::v-deep .danger-item {
  color: #f56c6c;
}

::v-deep .danger-item:hover {
  background: #fef0f0;
  color: #f56c6c;
}

/* 弹窗统一样式 */
::v-deep .custom-dialog .el-dialog__header {
  background: linear-gradient(135deg, #1485FB 0%, #0066CC 100%);
  padding: 16px 20px;
}

::v-deep .custom-dialog .el-dialog__title {
  color: white;
  font-size: 16px;
  font-weight: 500;
}

::v-deep .custom-dialog .el-dialog__headerbtn .el-dialog__close {
  color: white;
}

/* 导出选项 */
.export-options {
  padding: 10px 0;
}

.dialog-tip {
  color: #666;
  margin-bottom: 16px;
}

.radio-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}

.warning-text {
  color: #e6a23c;
  font-size: 13px;
  background: #fdf6ec;
  padding: 10px;
  border-radius: 4px;
}

/* 下载链接 */
.download-link {
  display: block;
  color: #1485FB;
  word-break: break-all;
  margin: 16px 0;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
}

/* 发布方式 */
.publish-methods {
  padding: 10px 0;
}

.method-item {
  margin-bottom: 24px;
}

.method-item h4 {
  font-size: 15px;
  color: #333;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.method-item h4 i {
  color: #1485FB;
}

.method-item p {
  color: #666;
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 12px;
}

.method-item .highlight {
  color: #1485FB;
  font-weight: 500;
}

.qrcode-box {
  text-align: center;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
}

.qrcode-box img {
  width: 180px;
  height: 180px;
}

/* 步骤引导 */
.steps-guide {
  padding: 10px 0;
}

.step-item-dialog {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  font-size: 14px;
  color: #555;
}

.step-num {
  width: 24px;
  height: 24px;
  background: #1485FB;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}

.qrcode-center {
  text-align: center;
  margin-top: 20px;
}

.qrcode-tip {
  color: #1485FB;
  font-weight: 500;
  margin-bottom: 12px;
}

.qrcode-img {
  width: 160px;
  height: 160px;
  border-radius: 8px;
  border: 1px solid #e8ecf1;
}

/* 确认弹窗 */
.confirm-content {
  padding: 10px 0;
}

.danger-text {
  color: #666;
  margin-bottom: 20px;
}

.verify-code {
  margin-bottom: 16px;
}

.verify-code .code {
  font-size: 20px;
  color: #f56c6c;
  font-weight: 600;
}

/* 响应式 */
@media (max-width: 768px) {
  .sidebar {
    display: none;
  }
  
  .content {
    padding: 12px;
  }
  
  .action-bar {
    flex-direction: column;
    align-items: stretch;
  }
}

/* 操作按钮美化 */
::v-deep .el-dropdown .el-button {
  border-color: #1485FB;
  color: #1485FB;
  transition: all 0.3s ease;
}

::v-deep .el-dropdown .el-button:hover {
  background: rgba(20, 133, 251, 0.1);
  border-color: #0066CC;
  color: #0066CC;
}
</style>



// WEBPACK FOOTER //
// src/components/query_list.vue